import { render, staticRenderFns } from "./MemoView.vue?vue&type=template&id=12d0a2e2&scoped=true&"
import script from "./MemoView.vue?vue&type=script&lang=js&"
export * from "./MemoView.vue?vue&type=script&lang=js&"
import style0 from "./MemoView.vue?vue&type=style&index=0&id=12d0a2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0a2e2",
  null
  
)

export default component.exports